import React from 'react';
import { format } from 'date-fns';

type CustomTickProps = {
  x: number;
  y: number;
  payload: any;
  index: number;
  chartType: string;
  selectedRange: string;
  TICK_GRANULARITY: Record<string, Record<string, number>>;
};

const CustomTick: React.FC<CustomTickProps> = ({
  x,
  y,
  payload,
  index,
  chartType,
  selectedRange,
  TICK_GRANULARITY,
}) => {
  const tickGranularity = TICK_GRANULARITY[chartType]?.[selectedRange] || 1;
  const shouldFormat = index % tickGranularity === 0;
  const formattedDate = shouldFormat ? format(new Date(payload.value), 'dd.MM.yy') : '';

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={7}
        textAnchor="middle"
        transform="rotate(-45)"
        fontSize={10}
        fill="#666"
      >
        {formattedDate}
      </text>
    </g>
  );
};

export default CustomTick;
